// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n2-3";
export var downloadButton = "_n2-4";
export var fileContainer = "_n2-9 _n2-7";
export var fileContainerBase = "_n2-7";
export var fileContainerFixedHeight = "_n2-8 _n2-7";
export var fileInfo = "_n2-5";
export var fileInfoWidthRestricted = "_n2-6";
export var fileType = "_n2-1";
export var fileTypeName = "_n2-2";
export var image = "_n2-0";
export var link = "_n2-b";
export var overflowEllipsis = "_n2-a";